import { ProductCategoryData } from '@/common/types/productCategory.type';

export enum CompanyContractConsumptionControlledBy {
  Currency = 'currency',
  Quantity = 'quantity',
}

export type CompanyContractData = {
  id: string;
  bill_by: string;
  bill_grouping_mode: string;
  closing_to_due_in_days: number;
  cnpj_for_fiscal_document: string;
  contract_equipment_categories: {
    id: string;
    equipment_category: {
      id: string;
      description: string;
      display_name: string;
      field_for_display: string;
      required_field_names: string[];
      unit_for_consumption: string;
    };
    quantity: number;
  }[];
  contract_fees: {
    id: string;
    fee_template: {
      id: string;
      applicable_entity: string;
      calculate_as: string;
      display_name: string;
      updated_at: string;
    };
    value: string;
  }[];
  contract_product_categories: {
    id: string;
    product_category: ProductCategoryData;
  }[];
  cycle: string;
  cycle_start_day: number;
  due_to_suspension_in_days: number;
  duration_in_months: number;
  file: {
    id: string;
    attachment_id: string;
    content_type: string;
    url: string;
  };
  fiscal_document_requirement: string;
  geo_geoables: any[];
  granted_credit: string;
  in_effect_since: string;
  in_effect_until: string;
  last_review: any;
  payment_method: string;
  payment_modality: string;
  protocol_number: string;
  state: string;
  consumption_controlled_by: CompanyContractConsumptionControlledBy;
};

export type CompanyContractResponse = {
  data: {
    data: CompanyContractData;
  };
};
